/**
 * Feature flags for controlling gradual rollout to public variant
 * Add new flags here as features are developed
 */
export enum FeatureFlag {
  NEARBY_FILTER = "NEARBY_FILTER",
  NEARBY_LOCKING = "NEARBY_LOCKING",
  TRENDING_LOCKING = "TRENDING_LOCKING",
}

/**
 * Check if a feature is ready for public variant
 * Returns true if feature should be visible in public, false for dev/preview only
 */
export function isReadyForPublicVariant(flag: FeatureFlag): boolean {
  switch (flag) {
    case FeatureFlag.NEARBY_FILTER:
      return false;
    case FeatureFlag.NEARBY_LOCKING:
      return true;
    case FeatureFlag.TRENDING_LOCKING:
      return false;
    default:
      return false; // default: dev/preview only
  }
}
